import styled from 'styled-components';

const Tail = styled.p`
  margin: 0;
  margin-top: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  > button, > span {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightHeavy};
    font-size: 16px;
    line-height: 16px;
  }

  > button {
    border: none;
    border-radius: 6px;
    height: 48px;
    width: 182px;

    &.view-more {
      color: ${props => props.theme.bodyColor};
      background: ${props => props.theme.secondaryColorLight};
      &:hover {
        background-color: #D7DFE7;
      }
    }
    &.view-all {
      color: ${props => props.theme.primaryColor};
      background: ${props => props.theme.primaryColorTransparent};
      &:hover {
        background-color: #E9E0C4;
      }
    }
  }

  > span {
    color: ${props => props.theme.secondaryColor};
  }
`;

export default Tail;
